import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SessionhandlerService } from './sessionhandler.service';
import { Router } from '@angular/router';
import { GlobalVariablesService } from '../layout/global-variables.service';
import { AppService } from '../app.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardGuard implements CanActivate {
  constructor(
    private session: SessionhandlerService,
    private router: Router,
    private globalService: GlobalVariablesService,
    public appService: AppService
  ) { }
  async canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot) {
    if (this.globalService.USER_ROUTE_ACCESS.length === 0) {
      const navItems = await this.appService.loadNavHeader();
      this.globalService.setUserRouteAccess(navItems);
    }
    let flag = false;
    this.globalService.USER_ROUTE_ACCESS.forEach(element => {
      if (state.url.includes(element)) {
        flag = true;
        return true;
      }
    });
    if (flag) {
      return true;
    }
    this.session.api.local.clear();
    this.session.api.session.clear();
    this.router.navigate(['/no-access']);
    return false;
  }
}
